var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseListV2',{attrs:{"model-class":_vm.ClientApp,"collection-filter":_vm.filter,"can-reorder":true,"help-message":"Client apps are collections of views and functions. They are used to grant a customized frontend to the user."}})}
var staticRenderFns = []

export { render, staticRenderFns }